import React from 'react';

const ChatIcon = ({ className = '', ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="22" 
      height="22" 
      viewBox="0 0 22 22" 
      fill="none"
      className={`${className}`}
      {...props}
    >
      <path 
        d="M11 21C16.523 21 21 16.523 21 11C21 5.477 16.523 1 11 1C5.477 1 1 5.477 1 11C1 12.6 1.376 14.112 2.043 15.453C2.221 15.809 2.28 16.216 2.177 16.601L1.582 18.827C1.52307 19.0473 1.52312 19.2792 1.58216 19.4995C1.64119 19.7197 1.75712 19.9206 1.91831 20.0819C2.07951 20.2432 2.2803 20.3593 2.50053 20.4184C2.72075 20.4776 2.95267 20.4778 3.173 20.419L5.399 19.823C5.78538 19.7254 6.19414 19.7727 6.548 19.956C7.93095 20.6446 9.45512 21.002 11 21Z" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default ChatIcon;
